<div class="flex-1 flex gap-5 py-7.5 px-8 shadow-block rounded-xl">
  <app-icon-block *ngIf="iconColor" [color]="iconColor" [icon]="icon" [stroke]="stroke"></app-icon-block>
  <div *ngIf="!iconColor" class="w-16 h-16" [inlineSVG]="'./assets/icons/' + icon"></div>
  <div>
    <p class="leading-none text-gray-400">{{ title | translate }}</p>
    <p class="text-5xl font-semibold text-sky-900">{{ data }}</p>
  </div>
</div>
